module.exports = __webpack_public_path__ + "669fb6af01d040686c75ea576884e423.svg";